import * as React from "react";
import {useCartContext} from "./CartContextProvider/CartContextProvider";
import {useTranslation} from "react-i18next";
import genericStyles from "../lib/GenericStyles.module.scss";
import {handleGotoErrorLinkClick} from "../../helpers/errorHandling";

const RedBorderBox: React.FC = () => {
  const {cart, cartErrors} = useCartContext();
  const {t} = useTranslation();

  if (!cartErrors.length) {
    return null;
  }

  return (
    <div className={genericStyles.errorBlockMain}>
      <ul>
        {cartErrors.map((entry, index) => {
          if (!entry.itemId) {
            return <li key={index}>{entry.message}</li>;
          }

          const deleteHandler = async (evt: React.MouseEvent<HTMLAnchorElement>) => {
            evt.preventDefault();
            await cart.removeItem(entry.itemId ?? 0);
          };

          if (entry.itemExists) {
            const jumpToHandler = (evt: React.MouseEvent<HTMLAnchorElement>) => {
              evt.preventDefault();
              handleGotoErrorLinkClick(`#error_item_${entry.itemId ?? 0}`);
            };

            return (
              <li key={index}>
                {entry.message}{" "}
                <React.Fragment>
                  <span className={genericStyles.jumpToError} onClick={jumpToHandler}>
                    {t("general.goToError")}
                  </span>
                  <span
                    className={`${genericStyles.jumpToError} ${genericStyles.deleteOnDesktop}`}
                    onClick={deleteHandler}
                  >
                    {t("general.delete")}
                  </span>
                </React.Fragment>
              </li>
            );
          }

          return (
            <li key={index}>
              {entry.message}{" "}
              <a href="#" onClick={deleteHandler}>
                {t("general.delete")}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default RedBorderBox;
